import { render, staticRenderFns } from "./BaseWindowListGeneral.vue?vue&type=template&id=95752a6a"
import script from "./BaseWindowListGeneral.vue?vue&type=script&lang=js"
export * from "./BaseWindowListGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports